'use es6';

import { getHsfsEligibility } from 'pricing-pages-unified-ui/api/HsfsApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchHsfsRequestTypes = createRequestTypes('HSFS');
export const FetchHsfsActions = createRequestActions(FetchHsfsRequestTypes);
export const fetchHsfsEligibility = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchHsfsActions,
    fetch: getHsfsEligibility
  })(dispatch);
};